<template>
	<div class="animated fadeIn">
		<h1 class="text-light">{{$t('device_status_list.title')}}</h1>

		<b-row>
			<b-col xl="12" lg="12" md="12">
		        <b-card v-if="show_device_list">
					<!--<input type="text" class="form-control" placeholder="搜尋" v-model="search_value" @keyup="search"></input>-->
					<v-server-table :columns="devicecolumns" :data="devicedata" :options="deviceoptions" :theme="theme" ref="deviceDataTable" id="deviceDataTable">
						<a slot="name" slot-scope="props">{{props.row.name ? props.row.name : $t('unknow')}}</a>
						<a slot="status" slot-scope="props"><span :id="'PCHolder'+props.row.id"><i class="fa fa-question-circle"></i></span></a>
					</v-server-table>
		    	</b-card>
		    </b-col>
	        
		</b-row>

		<b-modal :title="$t('qrcode_scanning')" v-model="showCameraModal" :ok-title="$t('ok')" :ok-only="true" :hide-footer="true" @hidden="hideScanner()">
		<b-alert :show="showCameraModal" variant="success"><i class="fa fa-exclamation-triangle"></i> {{$t('please_qrcode_scanning')}}</b-alert>
		<!-- <canvas id="qrcode-window" v-if="show_qrcode_canvas"></canvas> -->
		<!-- <video id="qrcode-video" playsinline muted></video> -->
		<video
			v-show="showCameraModal"
			id="qrvideo"
			autoplay
			muted
			loop
			playsinline
			webkit-playsinline
			style="border: 1px solid gray; width: 100%; height: 100%"></video>
		<p class="text-primary">{{qrcode_string}}</p>
		</b-modal>

		<b-modal :title="$t('error_message')" v-model="showErrorModal" :ok-title="$t('ok')" :ok-only="true">
			<b-alert :show="showErrorModal" variant="danger"><i class="fa fa-exclamation-triangle"></i> {{errorMsg}}</b-alert>
		</b-modal>
	</div>
</template>
<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import { hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import {ServerTable, Event} from 'vue-tables-2'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import io from 'socket.io-client'
import moment from 'moment-timezone'

import { BrowserQRCodeReader } from '@zxing/library';

const codeReader = new BrowserQRCodeReader();

let eventbus = config.eventbus;
let scanner  = null;

Vue.use(ServerTable)

let getUrlParameter = function getUrlParameter(url) {
  let sPageURL = url.substring(url.indexOf('?')+1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i,
      rlt={};

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      rlt[sParameterName[0]] = sParameterName[1];
  }

  return rlt;
};//eo getUrlParameter

let user_id_token_check = function(app){   
  let user = app.$state.$get('user');

  if(!user) {
    //console.info(`user_id_token_check no user`);
    return;
  }
  //console.info(`user_id_token_check user.uuid: ${user.uuid}`);

  let action = `${config.mqtt_root}/user_id_token_check`;
  fetch(action, {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + app.$state.$get('user').token
    },
    body: JSON.stringify({
    user_id: user.uuid
    })
  }).then(res => res.json()).then(result => {
    if(result.success === false){  
      //console.info(`user_id_token_check fail`); 
      app.showError({
        title: app.$t('user_check_error_title'),
        message: app.$t('user_check_error_message')
      });
      app.$state.$del('user');
      app.$router.push('/');
    }
  }).catch(error => {
    app.showError({
      title: app.$t('user_check_error_title'),
      message: app.$t('user_check_error_message')
    });
    app.$state.$del('user');
    app.$router.push('/');
  });
};

let status_update = function(app) {
	//console.info('app.status_records_ids:', app.status_records_ids);
	if(app && app.status_records_ids.length){
		let skip = {};
		let action = `${config.mqtt_root}/get_latest_charging_record`;
		fetch(action, {
			method: 'POST',
			headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + app.$state.$get('user').token
			},
			body: JSON.stringify({
				user_id:  1,
				device_ids: app.status_records_ids,
				keyset: 'mqtt',
			})
		}).then(res => res.json()).then(charging_records => {
			//console.info('charging_records:', charging_records);

			app.card_records.forEach((record) => {
				//console.info('record:', record);
				if(record.device_activated) {
					let is_open_time = true;
					let status = `<span class="text-success">${app.$t('device_status_list.standby')}</span>`;
					if(charging_records && charging_records.open_status) {
						let open_status = charging_records.open_status.find(item => item.id === record.id);
						if(open_status !== undefined) {
							is_open_time = open_status.is_open_time;
						}
					}
					if(!is_open_time) {
						status = `<span class="text-danger">${app.$t('device_status_list.not_open')}</span>`;
					}
					if(charging_records.success){
						let charging_record = charging_records.records.find(item => item.device_uid === record.id);
						if(charging_record !== undefined) {
							//console.info('found charging_record:', charging_record);
							if(charging_record.end_time && charging_record.end_time>charging_record.start_time){
								if(is_open_time) {
									status = `<span class="text-success">${app.$t('device_status_list.standby')}</span>`;
								}
							} else if(charging_record.stop_time){
								status = `<span class="text-warning">${app.$t('device_status_list.idling')}</span>`;
							} else if(charging_record.start_time) {
								status = `<span class="text-primary">${app.$t('device_status_list.charging')}</span>`;
							}
						}
					}
					jQuery('#PCHolder' + record.id).html(status);
				}
			});
		}).catch(error => {
		});
	}
};

export default {
	name: 'DeviceStatusList',
	components: {
		ServerTable,
		Event,
	},
	notifications,
	data(){
		let $tz = moment().tz(config.timezone);
    	let root = this;
		return {
			theme: '',
			keyword: '',
			status_records_ids: [],
			devicedata: [],
			card_records: [],
			card_record_count: 0,
			card_record_total_page: 1,
			card_current_page: 1,
			card_limit: 25,
			show_device_list: true,
			start_time:'',
			end_time:'',
			showErrorModal: false,
			showCameraModal: false,
			qrcode_string: '',
			errorMsg:'',
			refresh_time: null,
			devicecolumns: ['name','status'],
			deviceoptions: {
  			headings: {
				name: this.$t('device_status_list.deviceoptions.name'),
  				status: this.$t('device_status_list.deviceoptions.status'),
  			},
  			orderBy: {
  				column: 'name',
  				ascending: true
  			},
  			sortable: ['name'],
			filterable: [],
  			/*filterable: ['name'],
			customFilters:[{
				name: 'mysearch',
				callback: function(row, query) {
					console.info('customFilters:', query);
					return row.name[0] == query;
				}
			}],*/
  			sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
  			pagination: {
  				chunk: 5,
  				edge: false,
  				nav: 'scroll'
  			},
  			perPage: 25,
  			requestFunction(data) {
  				let app = this;
				let keyword = this.$state.$get('keyword');
				//console.info('keyword:', keyword);
  				let action = `${config.mqtt_root}/get_devices`;
  				let params = {
  					keyset: 'mqtt',
  					keyword: encodeURIComponent(keyword),
  				};

  				let ccff = this.$state.$get('ccff');
  				if(ccff){
  					params['ccff'] = ccff;
  				}

  				for(let col in data){
  					params[col] = data[col];
  				}

				return fetch(action, {
					method: 'POST',
					headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + app.$state.$get('user').token
					},
					body: JSON.stringify(params)
				}).then(res => res.json()).then(result => {
					//console.info('result:', result);
					root.card_records = result.data || [];
					root.card_record_count = result.count || 0;
					root.card_current_page = params.page;
					root.card_limit = params.limit;
					if (root.card_record_count) {
						root.card_record_total_page = Math.ceil(root.card_record_count / params.limit);
					}
					//console.info('app.card_records: ', root.card_records);
					return {
					data: result.data || [],
					count: result.count || 0
					};
				}).catch(error => {
					return {
					data: [],
					count: 0
					};
				});
  			}//eo requestFunction
			},
      		cameraDevices: [],
		}
	},//eo data
	created() {
		let app = this;
		
		app.$on('qrcodeDetected', function(result){
			//console.info('qr result:', result);
			
			app.$emit('reveived-qrcode', result);
			app.show_qrcode_canvas = false; 
			app.showCameraModal    = false;

			let params = getUrlParameter(result);
					
			if(params && params.uuid){
				app.uuid = decodeURIComponent(params.uuid);
				app.$state.$set('uuid', app.uuid);

				//Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
				let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
				uuid: app.uuid
				});

				// console.info('href:', href);

				window.location = href;

				location.reload();
			}
		});
	},
	mounted() {
		let app   = this;
		let user  = this.$state.$get('user');
		let token = user ? this.$state.$get('user').token : null;

    	//console.info(token);
		if(!user) {
			app.showError({message:app.$t('please_login')});
            let _vcc = setTimeout(() => {
              app.$router.push('/');
              clearTimeout(_vcc);
            }, 1500);
			return;
		}

		//Added force logout to avoid user.user_id encrypt with wrong iv/key when backend server restarting.
		user_id_token_check(app);

		if(!token){
			this.$state.$set('error', config.error.INVALID_USER);
	    	this.$router.push('/');
	    	return;
		}

		app.keyword = this.$route.query.keyword || null;
		if(app.keyword === null){
			let search_keyword = this.$state.$get('keyword');
			if(search_keyword){
				app.keyword = search_keyword;
				
				//write the UUID back to URL
				if(this.$route.query.keyword === undefined){
					location.href += '?' + jQuery.param({
						keyword: app.keyword
					});
				}
                
				this.$route.query.keyword = search_keyword;
			}
		}

		eventbus.$on('start-qrcode-scanning', this.openQrCodeScanner);

		this.handler = function(records) {
			// console.info('vue-tables.loaded:', records);
			app.status_records_ids = [];
			if(records) {
				records.data.forEach((record, idx) => {
					if(record.id){
						app.status_records_ids.push(record.id);

						//check connection status
						if(record.device_activated !== true) {
							jQuery('#PCHolder' + record.id).html(`<span class="text-danger">${app.$t('device_status_list.offline')}</span>`);
						}
					}
				});
				//console.info('vue-tables.loaded:', app.status_records_ids);
				status_update(app, app.status_records_ids);
			}
		};
		Event.$on('vue-tables.loaded', this.handler);

		app.refresh_time = setInterval(() => {
			//console.info('refresh_time');
			// 獲取當前頁碼
			const currentPage = app.$refs.deviceDataTable.page;
			// 使用Vue.nextTick確保DOM更新完成
			app.$nextTick(() => {
				// 設置回之前的頁碼(此會重新請求數據)
				app.$refs.deviceDataTable.setPage(currentPage);
			});
		}, 60000);
	},//eo mounted
	beforeDestroy(){
		Event.$off('vue-tables.loaded', this.handler);
		if(this.refresh_time) {
			clearInterval(this.refresh_time);
		}
	},

	watch: {
		'$i18n.locale'() {
			//console.info('watch $i18n.locale');
			this.$nextTick(() => {
				this.updateTableOptions();
			});
		},
	},

	methods: {
		openQrCodeScanner() {
			let app = this;

			app.showCameraModal       = true
			app.show_scan_qrcode_msg = true;
			app.show_qrcode_canvas   = true;

			// let _ccc = setTimeout(() => {
			//  clearTimeout(_ccc);
			//  init_qrcode_reader(app);
			// }, 1000);

			codeReader
			.listVideoInputDevices()
			.then((videoInputDevices) => {
				let targetCamera;
				videoInputDevices.forEach((device) => {
				this.cameraDevices.push(`${device.label}, ${device.deviceId}`);
				if (this.camera === 'front' && device.label.toLowerCase().indexOf('front') !== -1) {
					targetCamera = device.deviceId;
					return false;
				}
				return true;
				});
				codeReader
				.decodeFromInputVideoDevice(undefined, 'qrvideo')
				.then(result => this.onDecode(result.text))
				.catch(err => {
				// this.showError({message:this.$t('qr_code_detect_error')});
				console.error(err)
				});
			})
			.catch(err => { 
				this.showError({message:this.$t('qr_code_detect_error')});
				console.error(err)
			});

		},//eo openQrCodeScanner
		onDecode(data) {
			this.$emit('qrcodeDetected', data);
			this.showSuccess({message:this.$t('qr_code_detected')});
		},
		hideScanner(){
			// let app = this;
			// app.getVideo().stop();
			if(scanner !== null && scanner.destroy){
				scanner.destroy();
				scanner = null;
			}
		},//eo hideScanner
		gotoPage(page) {
			console.info('gotoPage: ', page);
			this.selected_page = page;
			this.$refs.deviceDataTable.setPage(page);
		},
		updateTableOptions() {
			this.deviceoptions.headings.name = this.$t('device_status_list.deviceoptions.name');
			this.deviceoptions.headings.status = this.$t('device_status_list.deviceoptions.status');
			this.$forceUpdate();
		},
	},//eo methods
}
</script>

<style>
.breadcrumb{display: none;}
.pt-3, .py-3 { padding-top: 0.35rem !important; }
.VueTables__search-field label, .VueTables__limit-field label{
	display: none;
	width: 0px;
}
</style>

<style src="spinkit/scss/spinkit.scss" lang="scss" />